import type { Pass } from '../live/satellites';
import { compassPoint, fmtMag } from './format';

const stamp = (t: number) => new Date(t).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

/** Save a visible pass as an .ics calendar event with a five-minute alert. */
export function downloadPassCalendar(name: string, p: Pass) {
  const start = p.visStart ?? p.rise;
  const end = p.visEnd ?? p.set;
  const desc =
    `Look ${compassPoint(p.visStartAz)} (${Math.round(p.visStartEl)}° up), it climbs to ${Math.round(p.peakEl)}° ` +
    `and fades ${compassPoint(p.visEndAz)}.${p.minMag != null ? ` Peak brightness about magnitude ${fmtMag(p.minMag)}.` : ''}`;
  const ics = [
    'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Ahillah//Sky//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT',
    `UID:${p.id}-${start}@ahillah`, `DTSTAMP:${stamp(Date.now())}`, `DTSTART:${stamp(start)}`, `DTEND:${stamp(end)}`,
    `SUMMARY:${name} ${p.peakEl >= 60 ? 'passes overhead' : p.peakEl >= 30 ? 'passes over' : `passes low in the ${compassPoint(p.peakAz ?? p.visStartAz)}`}`, `DESCRIPTION:${desc}`,
    'BEGIN:VALARM', 'ACTION:DISPLAY', `DESCRIPTION:${name} appears in 5 minutes`, 'TRIGGER:-PT5M', 'END:VALARM',
    'END:VEVENT', 'END:VCALENDAR',
  ].join('\r\n');
  const blob = new Blob([ics], { type: 'text/calendar' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${name.replace(/[^A-Za-z0-9]+/g, '-')}-pass.ics`;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(a.href);
    a.remove();
  }, 1000);
}
